const EXTENSIONS_BY_MIME_TYPE: Record<string, string> = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'application/pdf': 'pdf',
  'video/mp4': 'mp4',
  'video/quicktime': 'mov',
  'video/mpeg': 'mpeg',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'audio/mpeg': 'mp3',
  'text/csv': 'csv',
  'application/vnd.ms-excel': 'csv',
  'audio/wav': 'wav',
}

/**
 * Stored assets are keyed by uuid, so a name derived from the URL has no
 * extension and the saved file will not open. The response Content-Type is the
 * only place the real format survives.
 */
const withExtension = (fileName: string, mimeType: string) => {
  if (fileName.includes('.')) return fileName

  const extension = EXTENSIONS_BY_MIME_TYPE[mimeType?.split(';')[0]]
  return extension ? `${fileName}.${extension}` : fileName
}

/**
 * The `download` attribute is ignored on cross-origin URLs, and stored assets
 * are served from presigned S3 links, so the file has to be pulled into a blob
 * before it can be saved.
 */
export const downloadFile = async (url: string, fileName: string) => {
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`Failed to download ${fileName}`)
  }

  const blob = await response.blob()
  const objectUrl = URL.createObjectURL(blob)

  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = withExtension(fileName, blob.type)
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)

  URL.revokeObjectURL(objectUrl)
}
